import { PermissionMap } from "../store/slices/authSlice";

/**
 * Check single permission
 */
export const hasPermission = (
  permissions: PermissionMap,
  permission: string,
): boolean => {
  return !!permissions?.[permission];
};

/**
 * Check if user has ANY permission
 */
export const hasAnyPermission = (
  permissions: PermissionMap,
  requiredPermissions: string[],
): boolean => {
  return requiredPermissions.some((permission) => !!permissions?.[permission]);
};

/**
 * Check if user has ALL permissions
 */
export const hasAllPermissions = (
  permissions: PermissionMap,
  requiredPermissions: string[],
): boolean => {
  return requiredPermissions.every((permission) => !!permissions?.[permission]);
};
